import postWithToken from './base/post-with-token'

const updateCustomerGroup = (id, data) => postWithToken(`/customer/${id}/group`)(data)

export default updateCustomerGroup
